import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "title is-4" }
const _hoisted_2 = { class: "columns is-multiline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GhostCard = _resolveComponent("GhostCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, "Possible Ghosts (" + _toDisplayString(_ctx.ghosts.length) + ")", 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ghosts, (ghost) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "column is-4-fullhd is-6-desktop is-6-tablet",
          key: ghost.name
        }, [
          _createVNode(_component_GhostCard, {
            ghost: ghost,
            foundEvidence: _ctx.evidence
          }, null, 8, ["ghost", "foundEvidence"])
        ]))
      }), 128))
    ])
  ], 64))
}